// DC Keeper 執行期設定。
// API_URL / USE_MOCK / MOCK_LATENCY 由 .env 的 REACT_APP_* 注入（見 .env.example）。
module.exports = {
  // 後端 API base URL。留空時 axios 走相對路徑，由 mock 層攔截。
  // Swagger 到位後在 .env 設 REACT_APP_API_URL 即可切到真後端。
  API_URL: process.env.REACT_APP_API_URL || "",

  // 是否啟用前端 mock 層（後端 API 未到位時 = true）。
  // 預設：未明確設為 "false" 就啟用，方便開發。
  USE_MOCK: process.env.REACT_APP_USE_MOCK !== "false",

  // 混合模式("hybrid"):已串接的 /api-backend/* 放行到 REACT_APP_API_URL 真後端,
  // 其餘模組仍走 mock。漸進切換一律用 hybrid,USE_MOCK=false 留給全模組 API 到位後
  // (原因與事故背景見 .scratch/api-v1-integration/issues/07)。
  BACKEND_PASSTHROUGH: process.env.REACT_APP_USE_MOCK === "hybrid",

  // mock 回應延遲（毫秒），模擬網路延遲，方便驗骨架屏/載入態。
  MOCK_LATENCY: Number(process.env.REACT_APP_MOCK_LATENCY || 400),

  google: {
    API_KEY: "",
    CLIENT_ID: "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
};
